module.exports = __webpack_public_path__ + "img/background.0661b405.png";